import React from 'react';
import ABHomePage from '../pages/home/ABHomePage';

const ABHomeProvider = () => {
    return (
        <React.Fragment>
            <ABHomePage />
        </React.Fragment>
    );
}

export default ABHomeProvider;